import {
    Box,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Switch,
} from "@material-ui/core";
import { Role, User } from "api";
import { FieldArray, useFormikContext } from "formik";
import React from "react";

const changeRole = (push, remove, role: Role, roles: Role[]) => () => {
    const index = roles.indexOf(role);

    if (index < 0) {
        push(role);
    } else {
        remove(index);
    }
};

const RolesProfileForm = () => {
    const {
        values: { roles },
    } = useFormikContext<User>();

    return (
        <Box width="100%">
            <List>
                <FieldArray name="roles">
                    {({ push, remove }) => (
                        <>
                            <ListItem>
                                <ListItemText primary="Driver" />
                                <ListItemSecondaryAction>
                                    <Switch
                                        checked={roles.includes(Role.DRIVER)}
                                        onChange={changeRole(
                                            push,
                                            remove,
                                            Role.DRIVER,
                                            roles
                                        )}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Admin" />
                                <ListItemSecondaryAction>
                                    <Switch
                                        checked={roles.includes(Role.ADMIN)}
                                        onChange={changeRole(
                                            push,
                                            remove,
                                            Role.ADMIN,
                                            roles
                                        )}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Comissário" />
                                <ListItemSecondaryAction>
                                    <Switch
                                        checked={roles.includes(Role.COMISSARY)}
                                        onChange={changeRole(
                                            push,
                                            remove,
                                            Role.COMISSARY,
                                            roles
                                        )}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                        </>
                    )}
                </FieldArray>
            </List>
        </Box>
    );
};

export { RolesProfileForm };
